<template>
	<div class="study">
		<publicHeader @child-event="parentEvent"></publicHeader>
		<personalHeader :myInfo="myInfo"></personalHeader>
		
		<div class="personal bg_gray">
			<div class="w1200 flex">
				<personalNav :current="current"></personalNav>
				<div class="personal_r bg_white radius8">
					<div class="phone password">
						<div class="phone_title mab30 flex">
							<span class="f20px">修改密码</span>
							<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
						</div>
						<div class="logon_item">
							<p class="cl_gray f18px mab10">输入旧密码</p>
							<input type="password" v-model="password_old" placeholder="输入旧密码" class="logon_item_input f16px" />
						</div>
						<div class="logon_item">
							<p class="cl_gray f18px mab10">输入新密码</p>
							<input type="password" v-model="password" placeholder="输入新密码" class="logon_item_input f16px" />
						</div>
						<div class="logon_item">
							<p class="cl_gray f18px mab10">请再次确认新密码</p>
							<input type="password" v-model="password_two" placeholder="请再次确认新密码" class="logon_item_input f16px" />
						</div>
						<div class="phone_next cur tc f18px cl_white" @click="next">下一步</div>
					</div>
				</div>
			</div>
		</div>
		
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import vfooter from '../../components/footer.vue'
	import personalHeader from '../../components/personal_header.vue'
	import personalNav from '../../components/personal_nav.vue'
	export default {
	  name: 'password',
		components: {
			publicHeader,
			vfooter,
			personalHeader,
			personalNav,
		},
	  props: {
	    
	  },
		data () {
			return {
				myInfo: {},
				current: {
					navCur: 1,
					listCur: 0,
				},
				password_old: "", //旧密码
				password: "",//密码
				password_two: "",//确认密码
			}
		},
		mounted() {
			
		},
		created() {
			
		},
		methods: {
			parentEvent (data) {
				this.myInfo = data;
			},
			
			//下一步
			next () {
				if (this.password != this.password_two) {
					this.$message({
						duration: 1500,
						message: "密码不一致",
						type: 'error'
					});
					return false
				}
				this.$get("/api/user/post_pwd_edit",{
					original_pwd: this.password_old,
					new_pwd: this.password,
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.$message({
						duration: 2000,
						message: res.msg,
						type: 'success'
					});
					setTimeout(() => {
						this.$router.push({path: '/personal_protect'});
					}, 2000);
				});
			},
		},
	}
</script>

<style>
</style>
